import { theme } from '@Guidelines/Theme/theme';

export type IdentityTint = (typeof theme.tints)[keyof typeof theme.tints];

const TINT_COUNT = 4;

const TINT_KEY_BY_REMAINDER: Record<number, keyof typeof theme.tints> = {
	0: 'teal',
	1: 'green',
	2: 'amber',
	3: 'raspberry',
};

/**
 * Maps a stable seed (a database id works well) to one of the four identity tints: the same seed
 * always resolves to the same tint, so an identity keeps its color across reloads. Shared rather than
 * private to `IdentityTile` so that anything painted alongside a tile — a counter strip, a tinted
 * band — lands on the very same tint instead of drifting to a neutral that no longer matches it.
 */
const resolveIdentityTint = (seed: number): IdentityTint => {
	const tintKey = TINT_KEY_BY_REMAINDER[Math.abs(seed) % TINT_COUNT] ?? 'teal';

	return theme.tints[tintKey];
};

export default resolveIdentityTint;
